import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { select } from '@swf/core/store';

const sportsExchangeAlias = 'sportsExchange';
const searchVariableName = 'ifpath';

/**
 * React hook to determine if the loaded url is the Iframe Exchange url.
 * Returns tuple with first boolean if exchange url is present loaded
 * and second boolean if the url is the first loaded visit - no params and no hash in url
 */
export default function useIsExchange() {
  const { search } = useLocation();
  const activeAlias = useSelector(select.cms.getActiveAlias);
  const isMatchExchange = activeAlias === sportsExchangeAlias;
  const searchParams = new URLSearchParams(search);
  const firstVisit = isMatchExchange && !searchParams.get(searchVariableName);
  return [isMatchExchange, firstVisit];
}
